// extracted by mini-css-extract-plugin
module.exports = {"landing":"CI0htrWNSAeQ2EfFdkG70g=="};